import * as markerApi from '@/api/marker'
import { markerIconsConfig } from '@/utils/markerStyles'
import * as dataManagement from '@/api/dataManagement'
import { DataSet } from '@/libs/dataset/dataset.umd.min'
import GeoJSON from 'geojson'

const marker = {
  state: {
    selectedMarker: '', // 点击选中标注
    // 图层文件夹
    folderTree: [],
    // 图层列表
    layerList: [],
    // 标注数据
    markerDatas: [],
    // api数据集
    datasets: {},
    // api数据
    apiSourceDatas: {},
    // 标注显示状态
    layerVisibleStorage: {},
    // 图层树
    layerTree: {},
    // 标注图标
    markerIcons: {},
    modelHeight: 0,
    showViewShed3DBox: false,
    // 显示分屏对比
    showSplitScreenContrast: false,
    // 显示导入kml
    showImportkml: false,
    // 导入kml的类型（point、polyline、polygon）
    importkmlType: '',
    viewShed3DData: null,
    entitiesList: [],
    // 是否在标注编辑状态
    isInMarkerEditing: false,
    // 编辑标注数据
    editMarkerData: null,
    // 删除标注id
    removeMarkerId: '',
    // 体积测量标注
    volumeMeasureMarker: null,
    // 编辑标注位置更新
    markerPositionEdit: {},
    isShowSpaceSearchDraw: false,
    isShowSpaceTool: false,
    spaceSearchData: null,
    spaceSearchStatisticsData: null,
    spaceSearchJeojson: '',
    mapInfo: undefined
  },
  mutations: {
    SELECT_MARKER: (state, markerId) => {
      state.selectedMarker = markerId
    },
    SELECT_SPACESEARCHJEOJSON: (state, data) => {
      state.spaceSearchJeojson = data
    },
    SELECT_ISSHOWSPACESEARCHDRAW: (state, data) => {
      state.isShowSpaceSearchDraw = data
    },
    SELECT_SPACESEARCHDATA: (state, data) => {
      state.spaceSearchData = data
    },
    SELECT_SPACESEARCHSTATISTICSDATA: (state, data) => {
      state.spaceSearchStatisticsData = data
    },
    SELECT_ISSHOWSPACETOOL: (state, data) => {
      state.isShowSpaceTool = data
    },
    SET_LAYER_VISIBLE: (state, data) => {
      state.layerVisibleStorage = data
    },
    SELECT_MODELHEIGHT: (state, data) => {
      state.modelHeight = data
    },
    SELECT_SHOWVIEWSHED3DBOX: (state, data) => {
      state.showViewShed3DBox = data
    },
    SELECT_VIEWSHED3DDATA: (state, data) => {
      state.viewShed3DData = data
    },
    SET_EDIT_MARKER_DATA: (state, data) => {
      state.editMarkerData = data
    },
    SET_REMOVE_MARKER_ID: (state, data) => {
      state.removeMarkerId = data
    },
    SET_MARKER_POSITION_EDIT: (state, data) => {
      state.markerPositionEdit = data
    },
    SET_IN_MARKER_EDITING: (state, data) => {
      state.isInMarkerEditing = !!data
    },
    /**
     * 调用分屏对比的功能
     * @param {*} state
     * @param {*} data
     */
    SELECT_SPLITSCREENCONTRAST: (state, data) => {
      state.showSplitScreenContrast = data
    },
    SELECT_IMPORTKML: (state, data) => {
      if (typeof data === 'boolean') {
        state.showImportkml = data
      } else if (typeof data === 'object') {
        const { show = true, type = '' } = data
        state.importkmlType = type
        state.showImportkml = show
      }
    },
    // 销毁所有dataset
    destroyAllDatasets (state) {
      Object.values(state.datasets).forEach(item => {
        if (item) {
          item.destroy()
        }
      })
      state.datasets = {}
    },
    // 销毁dataset
    destroyDataset (state, apiId) {
      if (state.datasets[apiId]) {
        state.datasets[apiId].destroy()
        state.datasets[apiId] = undefined
      }
    },
    // 体积测量标注
    showVolumeMeasureBox (state, marker) {
      state.volumeMeasureMarker = marker
    },
    SET_MAP_INFO: (state, data) => {
      state.mapInfo = data
    }
  },
  actions: {
    selectMarker ({ commit }, markerId) {
      return new Promise((resolve, reject) => {
        commit('SELECT_MARKER', markerId)
      })
    },
    // 删除标注
    removeMarker ({ commit }, markerId) {
      return new Promise((resolve, reject) => {
        commit('SET_REMOVE_MARKER_ID', markerId)
      })
    },
    // 编辑标注位置
    setMarkerPositionEdit ({ commit }, markerId) {
      return new Promise((resolve, reject) => {
        commit('SET_MARKER_POSITION_EDIT', markerId)
      })
    },
    // 获取文件夹树
    getFolderTree ({ commit, dispatch, state, getters }, data) {
      return new Promise((resolve, reject) => {
        markerApi.getFolderTree({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            state.folderTree = response.data
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取图层树
    getLayerTree ({ commit, dispatch, state, getters }, data) {
      return new Promise((resolve, reject) => {
        markerApi.getLayerTree({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            const folderForeach = function (data, func) {
              if (data.layers || data.children) {
                func(data)
              }
              if (data.children) {
                for (let i = 0; i < data.children.length; i++) {
                  folderForeach(data.children[i], func)
                }
              }
            }
            state.layerTree = JSON.parse(JSON.stringify(response.data))
            // this.layerTree = {}
            folderForeach(state.layerTree, (item) => {
              if (item.children && item.children.length > 0) {
                for (let i = 0; i < item.children.length; i++) {
                  if (item.children[i].type) {
                    continue
                  }
                  item.children[i].clientId = 'folder-' + item.children[i].id
                  item.children[i].type = 'FOLDER'
                  item.children[i].markCount = 0
                }
              }
              if (item.layers && item.layers.length > 0) {
                if (!item.children) {
                  item.children = []
                }
                for (let i = 0; i < item.layers.length; i++) {
                  const layerItem = JSON.parse(JSON.stringify(item.layers[i]))
                  layerItem.clientId = 'layer-' + item.layers[i].id
                  layerItem.parentId = item.layers[i].groupId
                  item.children.push(layerItem)
                }
              }
            })
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取图层列表
    getLayerList ({ commit, dispatch, state, getters }, data) {
      return new Promise((resolve, reject) => {
        markerApi.getLayerList({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            state.layerList = response.data
            // 获取api数据列表
            state.layerList.forEach(item => {
              if (item.dataSourceType === 'API') {
                dispatch('getApiData', item)
              }
            })
            resolve(response)
            if (data.refreshMarker) {
              dispatch('getMarkerList')
            }
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取标注列表
    getMarkerList ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        markerApi.getAllMarkersGis({
          mapId: getters.curMapId
        }).then(response => {
          if (response.code === 200) {
            let sortRules = getters.layerList ? getters.layerList.map(item => { return item.id.toString() }) : []
            if (getters.mapInfo.sortRules) {
              sortRules = getters.mapInfo.sortRules.filter(item => { return item.startsWith('layer-') }).map(item => { return item.replace('layer-', '') })
            }
            response.data.forEach(item => {
              item.sort = sortRules.indexOf(String(item.id))
            })
            response.data.sort((a, b) => { return a.sort - b.sort })
            state.markerDatas = response.data
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取api数据
    async getApiData ({ commit, state, getters }, data) {
      const res = await dataManagement.getApiDetails({
        id: data.dataSourceId
      })
      if (res.code === 200) {
        const apiConfig = res.data.apiHttpConfig
        if (state.datasets[apiConfig.id]) {
          return
        }
        const schemas = []
        schemas.push({
          ...apiConfig,
          alias: []
        })
        const dataset = new DataSet(schemas)
        dataset.sources[0].on('change', (sourceData) => {
          // state.apiSourceDatas[apiConfig.id] = data
          const newData = JSON.parse(JSON.stringify(state.apiSourceDatas))
          newData[apiConfig.id] = sourceData
          state.apiSourceDatas = newData
        })
        state.datasets[apiConfig.id] = dataset
      }
    },
    // 获取标注图标库
    getMarkerIcons ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        markerApi.getIcons().then(response => {
          if (response.code === 200) {
            state.markerIcons = response.data
            const icons = JSON.parse(JSON.stringify(response.data))
            markerIconsConfig.STEREO = icons.STEREO ? icons.STEREO : {}
            markerIconsConfig.FLAT = icons.FLAT ? icons.FLAT : {}
            markerIconsConfig.PERSONAL = icons.PERSONAL ? icons.PERSONAL : {}
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 搜索本地标注
    searchMarker ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        const markers = []
        const { keyword } = data
        for (let i = 0; i < state.markerDatas.length; i++) {
          const layerData = state.markerDatas[i]
          if (!layerData.marks) {
            continue
          }
          for (let j = 0; j < layerData.marks.length; j++) {
            const marker = layerData.marks[j]
            if (marker.name.indexOf(keyword) >= 0) {
              markers.push({
                name: marker.name,
                id: marker.id,
                layerId: layerData.id,
                geoJson: marker.geoJson,
                markerType: layerData.type
              })
            }
          }
        }
        resolve({
          total: markers.length,
          records: markers
        })
      })
    },
    // 搜索融合通信标注
    searchSppucMarker ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        try {
          const markers = []
          const { keyword } = data
          for (let i = 0; i < state.layerList.length; i++) {
            const layerData = state.layerList[i]
            if (layerData.extendConfig && layerData.extendConfig.isSppucData) {
              const deviceType = layerData.extendConfig.deviceType
              const datas = window.sppucManager.getDevicesOl(deviceType).filter(item => {
                return item.name.indexOf(keyword) >= 0
              })
              for (let j = 0; j < datas.length; j++) {
                const marker = datas[j]
                const markerId = `sppuc-${layerData.id}-${marker.id}`
                const geoJson = GeoJSON.parse({
                  id: markerId,
                  lon: marker.position[0],
                  lat: marker.position[1],
                  name: marker.name,
                  deviceId: marker.id
                }, { Point: ['lat', 'lon'] })
                markers.push({
                  name: marker.name,
                  id: markerId,
                  layerId: layerData.id,
                  geoJson: geoJson,
                  markerType: 'POINT'
                })
              }
            }
          }
          resolve({
            total: markers.length,
            records: markers
          })
        } catch {
          resolve({
            total: 0,
            records: []
          })
        }
      })
    }
  }
}

export default marker
